import React from 'react';
import { RadarChart, Radar, PolarGrid, PolarAngleAxis, ResponsiveContainer, Legend } from 'recharts';

const data = [
  { dimension: 'Medição', netuno: 95, erp: 40, planilha: 20 },
  { dimension: 'EVM & KPIs', netuno: 90, erp: 25, planilha: 10 },
  { dimension: 'Auditoria', netuno: 95, erp: 50, planilha: 5 },
  { dimension: 'Contratos', netuno: 90, erp: 70, planilha: 15 },
  { dimension: 'Monte Carlo', netuno: 85, erp: 0, planilha: 0 },
  { dimension: 'Alertas', netuno: 85, erp: 20, planilha: 5 },
  { dimension: 'Relatórios', netuno: 90, erp: 50, planilha: 35 },
  { dimension: 'Databooks', netuno: 85, erp: 10, planilha: 0 },
  { dimension: 'Efetivo', netuno: 80, erp: 30, planilha: 20 },
  { dimension: 'Integração', netuno: 75, erp: 80, planilha: 30 },
];

const RadarComparisonChart: React.FC = () => (
  <div className="w-full h-[320px]">
    <ResponsiveContainer width="100%" height="100%">
      <RadarChart data={data} cx="50%" cy="50%" outerRadius="70%">
        <PolarGrid stroke="hsl(220, 15%, 88%)" />
        <PolarAngleAxis dataKey="dimension" tick={{ fontSize: 11, fill: 'hsl(220 10% 50%)' }} />
        <Radar name="NetUno" dataKey="netuno" stroke="hsl(168, 56%, 42%)" fill="hsl(168, 56%, 42%)" fillOpacity={0.25} strokeWidth={2} />
        <Radar name="ERP Genérico" dataKey="erp" stroke="hsl(38, 50%, 55%)" fill="hsl(38, 50%, 55%)" fillOpacity={0.1} strokeWidth={1.5} />
        <Radar name="Planilha + BI" dataKey="planilha" stroke="hsl(0, 0%, 65%)" fill="hsl(0, 0%, 65%)" fillOpacity={0.05} strokeWidth={1} />
        <Legend
          wrapperStyle={{ fontSize: '12px' }}
          formatter={(value) => <span className="text-xs text-muted-foreground">{value}</span>}
        />
      </RadarChart>
    </ResponsiveContainer>
  </div>
);

export default RadarComparisonChart;
